import React from 'react';
import { Link } from 'react-router-dom';
import Div from '../Div';
import './movingtext.scss';

export default function MovingText2({ data, reverseDirection }) {
  return (
    <Div className="_moving_text_wrap _type1 _bold _primary_font">
      <Div className="_moving_text_in">
        <Div
          className={
            reverseDirection
              ? '_moving_text _reverse_animation'
              : '_moving_text'
          }
        >
          {data.map((item, index) => (
            <>
              <Link key={index} to={item.href}>
                {item.title}
              </Link>
              
            </>
          ))}
        </Div>
        <Div
          className={
            reverseDirection
              ? '_moving_text _reverse_animation'
              : '_moving_text'
          }
        >
          {data.map((item, index) => (
            <>
              <Link key={index} to={item.href}>
                {item.title}
              </Link>
              
            </>
          ))}
        </Div>
      </Div>
    </Div>
  );
}
